module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-5.466b302f.png";